import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { Spin } from 'antd'

import './style.scss'
import uris from '../../../../config/uris'
import { decryptData } from '../../../../helpers/encrypt/crypto-encrypt'

const StripeCheckout = () => {
    const [checkoutUrl, setCheckoutUrl] = useState(null)

    const navigate = useNavigate()

    useEffect(() => {
        const url = decryptData(sessionStorage.getItem('stripeCheckoutUrl'))
        if (url) {
            setCheckoutUrl(url)
            window.location.href = url
            // window.open(url,'blank','width=400,height=400');
        } else {
            navigate(uris?.companyResearch)
        }
    }, [])

    return (
        <div className="stripe-checkout-container">
            {/* <div className="frame-wrapper">
                {checkoutUrl ? (
                    <iframe
                        src={checkoutUrl}
                        title="Stripe Checkout"
                        allow="payment"
                        className="stripe-frame"
                    >
                    </iframe>
                ) : (
                    <div className="frame-loader"><Spin /></div>
                )}
            </div> */}
        </div>
    )
}

export default StripeCheckout
